import { render, staticRenderFns } from "./FscInputDecimal.vue?vue&type=template&id=08965a42"
import script from "./FscInputDecimal.vue?vue&type=script&lang=ts"
export * from "./FscInputDecimal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports